import type { AppDispatch } from '@/store/types'
import type { IInitUser } from '@/store/user/interfaces'
import { setUser } from '@/store/user/user'
import { localStorageFields } from '@/constants/localStorage'

/**
 * Restores the session from the shared localStorage user (written by the tab
 * that logged in). Dispatching `setUser` lets the auth listener establish this
 * tab's own session — the same path used at app startup.
 */
export const restoreSession = (dispatch: AppDispatch) => {
  const raw = localStorage.getItem(localStorageFields.currentUser)
  if (!raw) {
    return
  }
  let user: IInitUser | null
  try {
    user = JSON.parse(raw)
  } catch {
    return
  }
  if (user) {
    dispatch(setUser(user))
  }
}
